import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import axios from "axios";

// 신청 페이지
import Consumer from "./consumer/consumer";
import Main from "./consumer/main/main";
import Step1 from "./consumer/apply/step1";
import Step2 from "./consumer/apply/step2";
import Step3 from "./consumer/apply/step3";
import Step4 from "./consumer/apply/step4";
import Inquiry from "consumer/inquiry/inquiry";
import Search from "consumer/inquiry/search/search";
import List from "consumer/inquiry/list/list";
import Result from "consumer/apply/result";
import { Error } from "consumer/apply/error";

// 관리 페이지
import Omega from "manager/omega/omega";
import Cmath from "manager/cmath/cmath";
import { auth } from "middleware/auth";

// 프로바이더
import OffcanvasProvider from "offcanvas/provider";


axios.defaults.baseURL = "/api/";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Consumer />,
        ErrorBoundary: Error,
		children: [
			{
				path: "/",
				element: <Main />,
			},
			{
				path: "/step1",
				element: <Step1 />,
			},
			{
				path: "/step2",
				element: <Step2 />,
			},
			{
				path: "/step3",
				element: <Step3 />,
				ErrorBoundary: Error,
			},
			{
				path: "/step4",
				element: <Step4 />,
				ErrorBoundary: Error,
			},
			{
				path: "/result",
				element: <Result />,
			},
			{
				path: "/inquiry",
				element: <Inquiry></Inquiry>,
				children: [
					{
						path: "",
						element: <Search />,
					},
					{
						path: "list",
						element: <List />,
					},
				],
			},
		],
	},
	{
		path: "/cmath",
		element: <Cmath />,
        loader: auth,
	},
	{
		path: "/omega",
		element: <Omega />,
        loader: auth
	},
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <OffcanvasProvider>
        <RouterProvider router={router}></RouterProvider>
    </OffcanvasProvider>
);
